import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { ApiStatusType, ApiStatusTypeMap } from '@tarslib/types/lib/httpApi';
import { Badge } from 'aui';
import clsx from 'clsx';
import styles from './ApiStatus.module.css';

export type ApiStatusProps = {
  status: ApiStatusType;
  className?: string;
};

export function ApiStatus(props: ApiStatusProps) {
  const { status, className } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const statusDetail = ApiStatusTypeMap[status];

  const isDeprecated = status === ApiStatusType.obsolete || status === ApiStatusType.deprecated;
  if (typeof status !== 'string' || !statusDetail || status === ApiStatusType.released) {
    return null;
  }

  return (
    <Badge
      size="small"
      className={clsx(
        'flex items-baseline rounded-full px-3 py-[3px] text-base font-400',
        styles.badge,
        className,
      )}
      color={statusDetail.color}
      status={statusDetail.value === ApiStatusType.released ? 'processing' : 'default'}
      text={clientI18n(`api.status.${status}`)}
      style={{
        background: isDeprecated ? 'transparent' : `rgba(var(--ui-${statusDetail.color}-6-p),0.08)`,
        color: isDeprecated ? 'var(--ui-text-color)' : `var(--ui-${statusDetail.color}-6)`,
      }}
    />
  );
}
